import { render, staticRenderFns } from "./ArrowBanner.vue?vue&type=template&id=24f33778&"
import script from "./ArrowBanner.vue?vue&type=script&lang=ts&"
export * from "./ArrowBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports